import { render, staticRenderFns } from "./EditionModal.vue?vue&type=template&id=2879caab"
import script from "./EditionModal.vue?vue&type=script&lang=ts"
export * from "./EditionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports